import { memo, useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { withNamespaces } from "react-i18next";

const Tabs = memo(({ t }) => {
  const [activeTab, setActiveTab] = useState("");
  const history = useHistory();
  const location = useLocation();

  const isActiveTab = (currentTab, tab) => currentTab === tab;

  const tabsLinks = [
    {
      key: "new-user",
      title: `${t("New User")}`,
    },
    {
      key: "existing-user",
      title: `${t("Existing User")}`,
    },
  ];

  useEffect(() => {
    setActiveTab(new URLSearchParams(location.search).get("tab"));
  }, [location.search]);

  useEffect(() => {
    if (!new URLSearchParams(location.search).get("tab")) {
      history.push("?tab=new-user");
    }
  }, [location.search]);

  return (
    <div
      style={{
        backgroundColor: "#D1D2D6",
      }}
    >
      <Nav tabs className="custom-style-1">
        {tabsLinks.map((link) => {
          return (
            <NavItem
              className={isActiveTab(activeTab, link.key) ? "active" : ""}
              key={link.key}
            >
              <NavLink
                className={isActiveTab(activeTab, link.key) ? "active" : ""}
                onClick={() => history.push(`?tab=${link.key}`)}
              >
                {t(link.title)}
              </NavLink>
            </NavItem>
          );
        })}
      </Nav>
    </div>
  );
});

export default withNamespaces()(Tabs);
